import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { addDays } from 'date-fns';
import { Button, Col, Form, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { StyleSheet, css } from 'aphrodite';
import Swal from 'sweetalert2';

import { FILE_EXPORTS_GENERATE_REPORTS } from 'lib/networking/endpoints';
import { ReportType } from 'lib/enums/ReportGeneratrionEnums';
import SwalDialog from 'lib/utils/toast';
import usePost from 'lib/hooks/usePost';
import {
  weeklyCycles,
  currentCycle,
  formatDateAsString,
} from 'components/settings/user_time_logs/UserTimeLogUtils';

function PaymentReportExportModal({ onHide, reportType }) {
  const [selectedCycles, setSelectedCycles] = useState([currentCycle]);

  const { postData: generateReport } = usePost(
    FILE_EXPORTS_GENERATE_REPORTS,
    () =>
      Swal.fire({
        icon: 'success',
        html: `
        <div>
          The export csv file will be generated in a while. 
          You can download the generated file from\n
          <a
            href="/file-exports"
            rel="noopener noreferrer"
            target="_blank"
          >
            File Exports Page
          </a>
        </div>`,
        title: 'Success',
        position: 'center',
      }),
    () => {
      SwalDialog('error', 'An error occurred while Generating the File', 'Error', 'center');
    },
  );

  const handleExportReport = () => {
    const paymentWeeks = selectedCycles.map(cycle => ({
      start_date: formatDateAsString(cycle.value),
      end_date: formatDateAsString(cycle.endDate),
    }));

    generateReport({
      report_type: reportType,
      payment_weeks: paymentWeeks,
    });
  };

  return (
    <Modal show={true} onHide={() => onHide(false)} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className={css(styles.heading)}>Export Payment Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {reportType === ReportType.USER_THROUGHPUT_REPORT && (
            <Form.Row className="mt-3">
              <Form.Group as={Col}>
                <Form.Label className="font-weight-bold">Weekly User Throughput Report</Form.Label>
                <Select
                  value={selectedCycles}
                  options={weeklyCycles}
                  onChange={cycles => setSelectedCycles(cycles)}
                  className="basic-single"
                  classNamePrefix="select"
                  isMulti
                />
              </Form.Group>
            </Form.Row>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => handleExportReport()}>
          Export
        </Button>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

PaymentReportExportModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  reportType: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  heading: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
});

export default PaymentReportExportModal;
